import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {PaymentItem, PaymentResponse} from "../../types/payments/paymentsSchema";
import {Pagination} from "features/model/types/groups/groupsLessonsSchema";


const initialState = {
    payments: [] as PaymentItem[],
    pagination: {} as Pagination,
    isLoading: true,
    error: null,
};


const paymentsSlice = createSlice({
    name: "payments",
    initialState,
    reducers: {
        setPayments: (state, action: PayloadAction<PaymentResponse>) => {
            const { items, pagination } = action.payload;
            state.payments = items;
            state.isLoading = false;
            state.pagination = pagination;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        paymentDeleted: (state, action: PayloadAction<number>) => {
            const deletedPaymentId = action.payload;
            state.payments = state.payments.filter(payment => payment.id !== deletedPaymentId);
        },

    },
});

export const { setPayments, paymentDeleted,setLoading } = paymentsSlice.actions;
export const paymentsReducer = paymentsSlice.reducer;


